// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Main_wrapper__ZE8Ob","text":"Main_text__3-236","info":"Main_info__1xU7N","link":"Main_link__1nuaM"};